import React from "react";

function BalTimeline() {
  return (
    <div>
      <h2 className="text-h-orange py-5">
        “If anything illustrates and puts into sharp relief Balochistan’s
        deprivations, both historical and current, it is the state of its
        prisons.”
      </h2>
      <p>- Author Radha Shah</p>
      <div className="row row-cols-1 row-cols-md-2 g-4">
        <div className="col">
          <img
            style={{ width: "80%" }}
            src={require("../../assets/images/baluchistan-agency-report.PNG")}
            alt="baluchistan-agency-report"
          />
          <br />
          <br />
          <br />
          <h2 className="text-h-black">
            Detention Through Colonial and Post-Colonial Times
          </h2>
          <br />
          <br />
          <br />
          <h2 className="text-hp-orange" style={{ fontSize: "22px" }}>
            Two areas of concern around imperial expenditure in Balochistan
            stand out: the transformation of the province into a territory for
            expanding British military presence to control the borders with
            Afghanistan and Iran; and the maintenance of ‘law and order’ under
            the British as the new self-proclaimed rulers of various tribal
            groups.
          </h2>
        </div>
        <div className="col">
          <div>
            <br />
            <br />
            <br />
            <p>
              Crowding aside, other problems persist, speaking volumes of the
              levels of under-resourcing and disenfranchisement in the province.
              The PPAC report notes that Central Prison Loralai, District Prison
              Killa Saifullah, District Prison Gwadar and District Prison
              Harnai, are all in such dire need of reconstructive improvement
              that they “are currently simply not liveable.”
            </p>
            <br />
            <br />
            <br />
            <p>
              In comparison with Punjab where 10% of prisons do not have
              ambulances, the PPAC Commission reported that Balochistan only has
              four prison ambulances for the whole province. Such
              under-resourcing extends to prisoners being unable to avail legal
              aid, and most jails do not provide vocational training
              opportunities. While there are over 100 identified mental health
              patients in prisons in the province, there are no specialists to
              attend to their needs. Underscoring this lack of material
              resources is a lack of opportunities for professional development
              of prison officials. Reportedly, the least developed of all
              sectors in the province, PPAC tabulated that 70% of the prison
              staff were untrained. Training centres do not exist in the
              province, and instead, prison officials must be sent to the
              National Academy for Prisons Administration in Lahore.
            </p>
          </div>
          <div>
            <div className="mt-5">
              <div className="d-flex">
                <div className="position-relative">
                  <div className="box-style"></div>
                </div>
                <div>
                  <h2 className="text-h-orange">
                    Under the British Crown Rule
                  </h2>
                  <p>
                    Examining the administrative reports of the Balochistan
                    Agency in the late 1800s reveals how British governors
                    institutionalised the tribunal <i>jirgas</i> to mete out
                    retributive and communal forms of justice.
                  </p>
                  <br />
                  <p>
                    The <i>jirgas</i> employed methods such as the payment of
                    blood money, or the stripping of resources from the
                    assailant’s household, which were distinct from the criminal
                    reform mandate employed by the Crown in Punjab and Sindh,
                    and even dissimilar from the federally administered tribal
                    regions with which it shared a border.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <div className="d-flex">
                <div className="position-relative">
                  <div className="box-style"></div>
                </div>
                <div>
                  <h2 className="text-h-orange">The Present</h2>
                  <p>
                    Today, Balochistan’s prisons remain the most under-resourced
                    in the country, while activists agitating for
                    enfranchisement say they are criminalised as seditious and
                    subject to extrajudicial violence.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BalTimeline;
